import HeroImg from "../../Assets/hero_image.png";
import { SlArrowDown } from "react-icons/sl";
import * as S from "./style";
import { Menu } from "../Menu";

export const HeroSection = () => {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <S.Content >
      <Menu />
      <S.Wrapper>
        <S.Mask
          className="mask-menu-hero-section"
          style={{
            top: '-280px',
            right: '2rem',
            width: '350px',
            height: '350px',
          }}
        />

        <S.MaskLeft />

        <S.MaskCenter />

        <S.luminosity />

        <S.WrapperFlex>
          <S.HeroImgComp
            src={HeroImg}
            alt="imagem de homem trabalhando com uns popups em cima da foto, com mapa e com um aviso de pressão interna saindo"
          />

          <S.TextBox>
            <S.Title>
              Tecnologia Preditiva para quem leva manutenção a sério
            </S.Title>

            <S.Text>
              O WisePrevent transforma inspeções, sensores e equipes em uma
              operação inteligente, segura e 100% rastreável — tudo em uma única
              plataforma.
            </S.Text>

            <S.ActionBtn
              className="action-btn"
              onClick={() =>
                window.open("https://wa.me/5541999981633", "_blank")
              }
            >
              Agende uma demonstração
            </S.ActionBtn>
          </S.TextBox>
        </S.WrapperFlex>

        <S.NavigationBtn onClick={() => scrollToSection("howItWorks")}>
          Saiba como funciona
          <SlArrowDown
            size={24}
            style={{
              color: "var(--orange-500)",
            }}
          />
        </S.NavigationBtn>
      </S.Wrapper>
    </S.Content>
  );
};
